import { useCallback, useMemo } from "react"

import { Flex } from "antd"
import dayjs from "dayjs"

import CompareSelect from "../../../Components/Filters/CompareSelect"
import { resolveCompare } from "../../../Components/Filters/DashboardFiltersBlock/resolveCompare"
import DropdownDateBlock from "../../../Components/Filters/DropdownDateBlock/DropdownDateBlock"
import { getCalculatedPeriod } from "../../../Utils/utils"

// "All time" has no bounds for a relative comparison to be derived from, so the compare is parked
// in `lastCompare` while it is selected and restored when a bounded period comes back — the same
// interplay Health → Status implements.
const HomeControls = ({ filters, onChangeFilter }) => {
  const handleChangeCustomDate = useCallback(
    (newFilters) => {
      if (!newFilters?.period) {
        onChangeFilter({ period: "27 days" })
        return
      }

      const nextPeriod = newFilters.period
      const wasAllTime = filters?.period === "all"

      if (nextPeriod === "all") {
        onChangeFilter({
          ...newFilters,
          lastCompare: filters?.compare || filters?.lastCompare || null,
          compare: null
        })
        return
      }

      const sourceCompare = wasAllTime ? filters?.lastCompare : filters?.compare

      onChangeFilter({
        ...newFilters,
        compare: resolveCompare(sourceCompare, nextPeriod),
        lastCompare: wasAllTime ? null : filters?.lastCompare
      })
    },
    [filters?.period, filters?.compare, filters?.lastCompare, onChangeFilter]
  )

  const compareCurrentValue = useMemo(() => {
    const calculated = getCalculatedPeriod(filters?.period)
    if (!calculated) return null
    const [from, to] = calculated
    return {
      preset: filters?.period?.type === "custom" ? "custom" : "relative",
      range: [
        dayjs.isDayjs(from) ? from.format("YYYY-MM-DD") : from,
        dayjs.isDayjs(to) ? to.format("YYYY-MM-DD") : to
      ]
    }
  }, [filters?.period])

  return (
    <Flex align="center" gap={12} wrap data-testid="home-controls">
      <DropdownDateBlock
        id={"period"}
        customOverlayClassName="dashboard-filters"
        label={"Custom"}
        iconType={"calendar_days"}
        setDropdownFilters={handleChangeCustomDate}
        dropdownFilters={getCalculatedPeriod(filters?.period)}
        presetId={filters?.__preset_period}
        inactive={false}
        alwaysShowLabel={false}
      />
      <CompareSelect
        currentValue={compareCurrentValue}
        value={filters?.compare}
        onChange={(value) => onChangeFilter({ compare: value })}
        disabled={filters?.period === "all"}
      />
    </Flex>
  )
}

export default HomeControls
